// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-lAIsQW","secondaryLabel":"secondaryLabel-wSCe_3","formLabel":"formLabel-DMDxtW","resetButton":"resetButton-UMstss"};